// src/components/SidebarLeft.js
import React from 'react';
import { List, ListItem, ListItemIcon, ListItemText, Divider, Card, CardContent, Typography, Avatar, Grid, Chip } from '@mui/material';
import PersonIcon from '@mui/icons-material/Person';
import BusinessIcon from '@mui/icons-material/Business';
import WorkIcon from '@mui/icons-material/Work';
import EditIcon from '@mui/icons-material/Edit';

export default function SidebarLeft() {

    const jobRecommendations = [
        {
            title: '高级前端工程师',
            company: 'TechCorp',
            time: '3天前',
        },
        {
            title: '全栈开发工程师',
            company: 'InnovateX',
            time: '1周前',
        },
    ];
    return (
        <div>

            {/* 个人资料卡片 */}
            <Typography variant="h6" gutterBottom>
                个人资料
            </Typography>
            <Card sx={{ marginBottom: 2 }}>
                <CardContent>
                    <Grid container spacing={2} alignItems="center">
                        <Grid item>
                            <Avatar src="https://via.placeholder.com/60" sx={{ width: 60, height: 60 }} />
                        </Grid>
                        <Grid item>
                            <Typography variant="h6">张三</Typography>
                            <Typography variant="body2" color="text.secondary">
                                Company
                            </Typography>
                            <Typography variant="body2" color="text.secondary">
                                东京 前端开发工程师
                            </Typography>
                        </Grid>
                    </Grid>
                    {/* <Typography variant="body2" color="text.secondary" sx={{ marginTop: 1 }}>
                        个人简介摘要内容，可以简短描述一下自己...
                    </Typography> */}
                </CardContent>
            </Card>
            <List component="nav">
                <ListItem button>
                    <ListItemIcon>
                        <WorkIcon />
                    </ListItemIcon>
                    <ListItemText primary="我的简历" />
                </ListItem>
                <ListItem button>
                    <ListItemIcon>
                        <BusinessIcon />
                    </ListItemIcon>
                    <ListItemText primary="企业认证" />
                </ListItem>
                <ListItem button>
                    <ListItemIcon>
                        <EditIcon />
                    </ListItemIcon>
                    <ListItemText primary="我的招聘" />
                </ListItem>
                <Divider />
            </List>

            {/* 职业机会推荐 */}
            <Typography variant="h6" gutterBottom sx={{ marginTop: 4 }}>
                职位推荐
            </Typography>
            <Grid container spacing={2}>
                {jobRecommendations.map((job, index) => (
                    <Grid item xs={12} sm={12} md={12} key={index}>
                        <Card>
                            <CardContent>
                                <Typography variant="h6">{job.title}</Typography>
                                <Typography variant="body2" color="text.secondary">
                                    {job.company}
                                </Typography>
                                <Typography variant="caption" color="text.secondary">
                                    {job.time}
                                </Typography>
                            </CardContent>
                        </Card>
                    </Grid>
                ))}

                <Card>
                    <CardContent>
                        <div style={{ textAlign: 'center' }}>
                            <Chip label="更多" sx={{ margin: 0.5 }} />
                        </div>
                    </CardContent>
                </Card>
            </Grid>
        </div>
    );
}
